import { useMutation, useQueryClient } from 'react-query'
import { QueryNames } from 'Hooks/api/queryNames'
import { toast } from 'react-toastify'
import { AppNotification } from 'Utils/types/appNotification'
import { updatePricingDescription } from 'Services/JOONAdmin/joonAdminEmployersService'

export const useUpdatePricingDescriptionQuery = () => {
  const queryClient = useQueryClient()

  return useMutation([QueryNames.UpdatePricingDescription], updatePricingDescription, {
    onSuccess: (response) => {
      if (response.success) {
        queryClient.invalidateQueries([QueryNames.EmployerDashboard])
        toast.success(AppNotification.UpdatePricingDescriptionSuccess)
      } else {
        toast.error(`${AppNotification.UpdatePricingDescriptionFailure} ${response.message}`)
      }
    },
    onError: () => {
      toast.error(AppNotification.UpdatePricingDescriptionFailure)
    }
  })
}
